// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoleAndPermission_wrapper__x9ql5","wrapper__createBtnContainer":"RoleAndPermission_wrapper__createBtnContainer__33XXG"};